export default {"src":"/_next/static/media/outcomes.0a2e4a07.svg","height":544,"width":891,"blurWidth":0,"blurHeight":0};